import { keepPreviousData, useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchWorkspaceEmailLog, fetchWorkspaceEmailLogEntry } from '@/api/emailLog/emailLogApi';
import type {
  EmailLogEntryDetail,
  EmailLogEntrySummary,
  EmailLogQuery,
} from '@/api/emailLog/emailLogApi.types';
import type { PaginatedResult } from '@/api/pagination.types';
import {
  WORKSPACE_EMAIL_LOG_QUERY_KEY,
  buildWorkspaceEmailLogEntryQueryKey,
} from '@/constants/queryKeys';

export function useWorkspaceEmailLogQuery(
  query: EmailLogQuery
): UseQueryResult<PaginatedResult<EmailLogEntrySummary>, Error> {
  return useQuery({
    queryKey: [...WORKSPACE_EMAIL_LOG_QUERY_KEY, 'list', query],
    queryFn: function loadEmailLog() {
      return fetchWorkspaceEmailLog(query);
    },
    placeholderData: keepPreviousData,
  });
}

export function useWorkspaceEmailLogEntryQuery(
  entryId: string
): UseQueryResult<EmailLogEntryDetail, Error> {
  return useQuery({
    queryKey: buildWorkspaceEmailLogEntryQueryKey(entryId),
    queryFn: function loadEmailLogEntry() {
      return fetchWorkspaceEmailLogEntry(entryId);
    },
  });
}
